import {
  postJwtRegister,
} from "../../../helpers/fakebackend_helper";

import {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  apiErrorChange
} from "./reducer";

export const registerUser = (user: any,navigate:any) => async (dispatch: any) => {
  try {
    const response = await postJwtRegister("/accounts/signup", user);
    const data: any = response;
    if (data?.status === "SIGNUP_DONE") {
      dispatch(registerUserSuccessful(data));
      setTimeout(() => {
        navigate("/csignupends")
      }, 2000);
    } else if (data?.status === "ERROR") {
      dispatch(registerUserFailed(data?.error || "Signup failed"));
      setTimeout(() => {
        dispatch(registerUserFailed(null)); 
      }, 2000)
      return data || "Signup failed";
    }
  } catch (error: any) {
    dispatch(registerUserFailed({ error: error || "Something went wrong" }));
    setTimeout(() => {
      dispatch(registerUserFailed(null)); 
    }, 4000);
  }
};

export const resetRegisterFlag = () => {
  try {
    const response = resetRegisterFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};

export const apiError = () => {
  try {
    const response = apiErrorChange("");
    return response;
  } catch (error) {
    return error;
  }
};